import './utils/amapSecurityEarly'
import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import './styles/index.scss'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
// dayjs 全局语言设为中文：zh-cn 的 weekStart=1，让 el-calendar 等周组件按中国习惯从周一开始
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import katex from 'katex'
import 'katex/dist/katex.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import BaseButton from '@/components/base/BaseButton.vue'
import BaseInput from '@/components/base/BaseInput.vue'
import BaseCard from '@/components/base/BaseCard.vue'
import BaseSelect from '@/components/base/BaseSelect.vue'
import BaseTag from '@/components/base/BaseTag.vue'
import { loadTabs, filterValidTabs, getCurrentUserId } from '@/utils/tabs'

// 处理 ResizeObserver 错误
const debounce = (fn, delay) => {
  let timer = null
  return function () {
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(this, arguments)
    }, delay)
  }
}

// 防抖处理 ResizeObserver 循环，并捕获可能的 DOM 错误
const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    const wrappedCallback = debounce((...args) => {
      try {
        callback.apply(this, args)
      } catch (e) {
        const message = String(e?.message || e)
        // 忽略组件销毁/DOM 未就绪阶段常见的测量异常
        if (
          message.includes('getBoundingClientRect') ||
          message.includes('getComputedStyle') ||
          message.includes("parameter 1 is not of type 'Element'")
        ) {
          console.warn('ResizeObserver DOM 未就绪（已忽略）:', message)
        } else {
          throw e
        }
      }
    }, 16)
    super(wrappedCallback)
  }
}

// 处理 Element Plus 组件的 getBoundingClientRect 错误（通常在 DOM 未就绪时发生）
window.addEventListener('error', (event) => {
  const message = String(event?.message || '')
  if (
    message.includes('getBoundingClientRect') ||
    message.includes('getComputedStyle') ||
    message.includes("parameter 1 is not of type 'Element'")
  ) {
    event.preventDefault()
    console.warn('Element Plus DOM 未就绪警告（已忽略）:', message)
    return false
  }
})



const app = createApp(App)

dayjs.locale('zh-cn')

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 注册基础设计系统组件
app.component('BaseButton', BaseButton)
app.component('BaseInput', BaseInput)
app.component('BaseCard', BaseCard)
app.component('BaseSelect', BaseSelect)
app.component('BaseTag', BaseTag)

app.use(store)
   .use(router)
   .use(ElementPlus, {
     locale: zhCn,
     size: 'default',
     zIndex: 3000
   })
   .mount('#app')

// 暴露 router 到全局
window.router = router
window.katex = katex

// 初始化用户状态
const token = localStorage.getItem('token')
const user = localStorage.getItem('user')
console.log('初始化用户状态:', { token: !!token, userExists: !!user })

if (token && user) {
  try {
    const userData = JSON.parse(user)
    store.commit('auth/SET_TOKEN', token)
    store.commit('auth/SET_USER', userData)

    // 启动时刷新一次用户快照：管理员改权限后无需退出重登即可生效
    store.dispatch('auth/fetchUserInfo').catch(() => {})

    console.log('用户状态已初始化:', {
      token: !!token,
      userData: {
        username: userData.username,
        role: userData.role,
        isAdmin: userData.isAdmin
      }
    })

    // 从 localStorage 恢复 tabs，过滤掉无权访问或路由失效的项
    const persisted = loadTabs(getCurrentUserId())
    if (persisted?.visitedTabs?.length) {
      const valid = filterValidTabs(persisted.visitedTabs, router)
      store.dispatch('tabs/hydrate', {
        visitedTabs: valid,
        activeKey: valid.find((t) => t.key === persisted.activeKey)
          ? persisted.activeKey
          : ''
      })
    }
  } catch (error) {
    console.error('解析用户数据失败:', error)
  }
}

// 添加路由调试
router.beforeResolve((to, from, next) => {
  console.log('路由解析中:', { 
    to: to.path, 
    from: from.path,
    isAuthenticated: store.getters['auth/isAuthenticated'],
    token: !!localStorage.getItem('token')
  })
  next()
})
